/* eslint-disable @typescript-eslint/no-namespace */
/**
 * Static enums extracted from: @tencent/tpro_rmonitor_product_manager_product_permissions
 * DO NOT EDIT MANUALLY — run "npm run gen:proto-enums" to regenerate.
 *
 * Zero dependencies — only static enum definitions.
 * Supports nested namespace access: enumTrpc.rmonitor.web_server.IssueType
 */

export namespace enumTrpc {
  export namespace rmonitor {
    export namespace product_manager {
      export enum FeatureType {
        FEATURE_TYPE_UNKNOWN = 0,
        FEATURE_TYPE_OVERVIEW_DASHBOARD_METRICS = 1,
        FEATURE_TYPE_OVERVIEW_QUALITY_REPORT = 2,
        FEATURE_TYPE_OVERVIEW_VERSION_METRICS = 3,
        FEATURE_TYPE_OVERVIEW_BUSINESS_DRILLDOWN = 4,
        FEATURE_TYPE_OVERVIEW_MY_DASHBOARD = 5,
        FEATURE_TYPE_OVERVIEW_PUBLIC_DASHBOARD = 6,
        FEATURE_TYPE_CRASH = 7,
        FEATURE_TYPE_ERROR = 8,
        FEATURE_TYPE_ANR = 9,
        FEATURE_TYPE_OOM = 10,
        FEATURE_TYPE_FOOM = 11,
        FEATURE_TYPE_FOOM_MALLOC = 12,
        FEATURE_TYPE_LAG = 13,
        FEATURE_TYPE_LAUNCH = 14,
        FEATURE_TYPE_MEM_LEAK = 15,
        FEATURE_TYPE_BITMAP = 16,
        FEATURE_TYPE_MEMORY_DETAIL = 17,
        FEATURE_TYPE_FD_LEAK = 18,
        FEATURE_TYPE_NATIVE_MEM = 19,
        FEATURE_TYPE_BADMALLOC = 20,
        FEATURE_TYPE_METRICKIT = 21,
        FEATURE_TYPE_LAG_TREE = 22,
        FEATURE_TYPE_APP_EXIST = 23,
        FEATURE_TYPE_TRAFFIC = 24,
        FEATURE_TYPE_BATTERY = 25,
        FEATURE_TYPE_NETWORK = 26,
        FEATURE_TYPE_LAG_ANR_TRACE = 27,
        FEATURE_TYPE_PAGE_LAUNCH = 29,
        FEATURE_TYPE_DIAGNOSE_LOG = 30,
        FEATURE_TYPE_ADVANCED_SEARCH = 31,
        FEATURE_TYPE_SETTING_SDK_CONFIG = 33,
        FEATURE_TYPE_SETTING_ALERT = 34,
        FEATURE_TYPE_SETTING_SYMBOL = 35,
        FEATURE_TYPE_SETTING_ISSUE_CLUSTER = 36,
        FEATURE_TYPE_RUM_API = 101,
        FEATURE_TYPE_RUM_LOG = 102,
        FEATURE_TYPE_RUM_PV = 103,
        FEATURE_TYPE_RUM_JS = 104,
        FEATURE_TYPE_RUM_EVENT = 105,
        FEATURE_TYPE_RUM_CUSTOM = 106,
        FEATURE_TYPE_RUM_STATIC = 107,
        FEATURE_TYPE_RUM_PAGE_LOAD = 108,
        FEATURE_TYPE_RUM_PERFORAMANCE_LAUNCH = 109,
        FEATURE_TYPE_RUM_PERFORAMANCE_RUNNING = 110,
        FEATURE_TYPE_RUM_PERFORAMANCE_PAGE = 111,
        FEATURE_TYPE_RUM_HIPPY_PERFORAMANCE = 112,
        FEATURE_TYPE_COMPLIANC_API = 301,
        FEATURE_TYPE_COMPLIANC_FUNC_INVOKE = 302,
        FEATURE_TYPE_COMPLIANC_DOWNLOAD_MONITOR = 303,
        FEATURE_TYPE_COMPLIANCE_SELF_LAUNCH = 304,
        FEATURE_TYPE_COMPLIANCE_NETWORK_CAPTURE = 305,
        FEATURE_TYPE_COMPLIANC_PERMISSION = 306,
        FEATURE_TYPE_COMPLIANCE_FILE_ACCESS = 307,
      }

      export enum ProductType {
        UNKNOWN_PRODUCT = 0,
        PAID_PRODUCT = 1,
        FREE_PRODUCT = 2,
        NORMAL_PRODUCT = 3,
      }

      export enum OrgType {
        UNKNOWN_ORG = 0,
        COMPANY = 1,
        ORGANIZATION = 2,
        INDIVIDUAL = 3,
      }

      export enum AppForm {
        UNKNOWN_FORM = 0,
        APP = 1,
        SDK = 2,
        EXTENSION = 3,
      }

    }

  }

}
